// extracted by mini-css-extract-plugin
export default {"storeactionblog":"storeactionblog_f4a6d893b332e06932c7"};